<template>
  <section class="wrapper">
    <div class="container">
      <div class="works">

          <div
            v-for="(title, index) in titles"
            class="blog-card"
            v-bind:style="{backgroundImage: 'url(' + images[index] + ')'}"
            v-bind:key="title.id"
          >
            <div class="title-content">
              <h3 v-bind:style="{color: styles[index]}"><a v-bind:href="hr[index]" target="_blank">{{title}}</a></h3>
              <hr />
            </div>
            <div class="card-info">
              <p v-text="text[index]"></p>
            </div>

            <div class="utility-info">
              <h5>
                Made with
                <i class="fas fa-heart"></i> by Ulugbek
              </h5>
            </div>
            <div class="gradient-overlay"></div>
            <div class="color-overlay"></div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import ph1 from "./assets/eurohouse-min.png";
import ph2 from "./assets/fruits-min.png";
import ph3 from "./assets/logic-min.png";

export default {
  name: "works",
  data: () => {
    return {
      titles: ["Eurohouse", "Fruit", "Bearing Asia"],
      text: [
        "Компания осуществляет ремонт и отделочные работы помещений квартир, коттеджей, домов, офисов, магазинов, а так же производственных и складских помещений. Dыполняет все виды отделочных работ с благоустройством прилегающей территории.",
        "Фрукты – незаменимый источник клетчатки, витаминов и просто хорошего настроения. Без поставок свежих фруктов не обойдется ни крупный супермаркет, ни ресторан, ни кафе. Ведь фрукты добавляются при приготовлении многих мясных блюд и десертов, они кладутся в мороженое, являются начинкой для выпечки.",
        "Компания Bearing Asia занимается транспортировкой грузов по всему миру любым удомбным для заказчиков видом транспорта. Это стратегическое управление цепочками поставок на всем пути движения. Наша задача заключается не просто в организации отдельно взятой перевозки, а в предложении клиенту оптимального решения его транспортно-логистических задач."
      ],
      styles: ["#222f3e", "#c0392b", "#c8d6e5"],
      images: [ph1, ph2, ph3],
      hr: ["https://gkwd.github.io/eurohouse/index.html", "https://gkwd.github.io/fruits/index.html", "https://gkwd.github.io/logic/index.html"]
    };
  }
};
</script>

<style>
.works {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
}

.blog-card {
  width: 350px;
  height: 500px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.5);
  text-align: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  margin-bottom: 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.blog-card .color-overlay {
  /* background: rgba(84, 104, 110, 0.4); */
  width: 350px;
  height: 500px;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  transition: all 0.3s cubic-bezier(0.33, 0.66, 0.66, 1);
}

.blog-card:nth-child(1) .color-overlay {
  background: rgba(84, 104, 110, 0.4);
}
.blog-card:nth-child(2) .color-overlay {
  background: rgba(47, 154, 10, 0.4);
}
.blog-card:nth-child(3) .color-overlay {
  background: rgba(3, 78, 162, 0.4);
}

.blog-card:hover:nth-child(1) .color-overlay {
  background: rgba(84, 104, 110, 0.8);
}
.blog-card:hover:nth-child(2) .color-overlay {
  background: rgba(47, 154, 10, 0.8);
}
.blog-card:hover:nth-child(3) .color-overlay {
  background: rgba(3, 78, 162, 0.8);
}

.blog-card .gradient-overlay {
  background-image: -webkit-linear-gradient(
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 21%
  );
  background-image: -moz-linear-gradient(
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 21%
  );
  background-image: -o-linear-gradient(
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 21%
  );
  background-image: linear-gradient(
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 21%
  );

  width: 350px;
  height: 500px;
  position: absolute;
  top: 350px;
  left: 0;
  z-index: 15;
}
.blog-card:hover .card-info {
  opacity: 1;
  bottom: 90px;
}

.title-content {
  margin: 70px 0 0 0;
  z-index: 20;
  width: 100%;
}

.title-content h3 {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 2px;
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  margin-bottom: 0;
}

hr {
  width: 50px;
  height: 3px;
  margin: 20px auto;
  border: 0;
  background: rgb(255, 211, 0);
}
.card-info {
  width: 100%;
  position: absolute;
  bottom: 70px;
  text-align: left;
  left: 0;
  box-sizing: border-box;
  padding: 0 25px;
  color: #dce3e7;
  font-family: "Roboto", sans-serif;
  font-style: 16px;
  line-height: normal;
  z-index: 20;
  opacity: 0;
  transition: bottom 0.3s, opacity 0.3s cubic-bezier(0.33, 0.66, 0.66, 1);
}

.utility-info {
  position: absolute;
  bottom: 0px;
  width: 100%;
  z-index: 20;
}
.utility-info h5 {
  color: #d0bb57;
  display: flex;
  margin: 15px;
  font-size: 15px;
  font-weight: 500;
}
.utility-info h5 .fas {
  color: #c0392b;
  margin-left: 6px;
  margin-right: 6px;
}
</style>


// WEBPACK FOOTER //
// src/works.vue